export default {
  // 登录页
  login: {
    lang: 'language',
    systemname: 'Face Login',
    username: 'username',
    username_label: 'Please input one user name',
    pwd: 'password',
    pwd_label: 'Please input a password',
    pwd_info: 'Please enter the correct password format',
    success_msg: 'Login successfully',
    error_name: 'Wrong password',
    error_res: 'Does not meet the login requirements',
    login: 'Login',
  },
  // 侧边栏部分
  aside: {
    systemname: 'Face System',
    help: 'Help',
    administrator: 'Administrator',
    quit: 'Quit',
    deviceControl: 'Control',
    basicSetting: 'Settings',
    workerSetting: 'Personnel',
    deviceMonitoring: 'Monitoring',
    recordManagement: 'Records',
    securityManagement: 'Key',
    tips: 'Tips',
    tips_msg: 'Do you want to log out',
  },
  // 设备控制页面
  control: {
    remoteControl: 'Remote',
    restart: 'Restart',
    clickToRestart: 'Click to restart the device',
    restartConfirm: 'Are you sure you want to restart the device?',
    restartSuccess: 'Successful restart',
    restartFailed: 'Failed to restart',
    remoteOpen: 'Remote door opening',
    clickToOpen: 'Click remote door opening',
    openConfirm: 'Are you sure you want to open the door remotely?',
    remoteOpenSuccess: 'Remote door opening successful',
    remoteOpenFailed: 'Remote door opening failed',
    reset: 'Device reset',
    clickToReset: 'Click reset device',
    resetConfirm: 'Are you sure you want to reset the device?',
    resetSuccess: 'The device reset was successful',
    resetFailed: 'Device reset failed',
    firmwareUpgrade: 'Equipment upgrade',
    upgradeConfig: 'Upgrade configuration',
    firmwareUrl: 'Firmware address',
    md5Checksum: 'md5 value',
    startUpgrade: 'Start upgrading',
    urlRequired: 'The file address is mandatory',
    md5Required: 'The md5 value is required',
    urlInvalid: 'Please enter the correct address',
    md5Invalid: 'Please enter the correct md5',
    upgradeConfirm: 'Are you sure you want to upgrade the equipment?',
    upgradeSuccess: 'The equipment upgrade was successful.',
    clearFile: "Clear the file",
    uploading: 'Uploading',
    uploadAndUpgrade: 'Upload and upgrade',
    restartTips: 'Safely restart the device system without losing data',
    restarting: 'Restarting...',
    remoteTips: 'Remotely control the access control device to open',
    opening: 'Opening...',
    resetTips: 'Restore factory Settings and clear all data',
    reseting: 'Reseting...',
    urlUpgrade: 'URL upgrade method',
    fileUpgrade: 'File upload upgrade',
    uploadFile: 'Click to upload the firmware file',
    formatFile: 'Supports.zip or.dpk format files, with a maximum size of 20MB',
    fileName: 'File name',
    size: 'Size',
  },
  config: {
    second: 's',
    millisecond: 'Milliseconds',
    min: 'Minutes',
    notsave: 'Not saved',
    save: 'Save',
    noVoice: 'No voice',
    no: 'NO',
    yes: 'YES',
    // 基础配置
    basicConfiguration: 'Basic configuration',
    informationDisplay: 'Information display',
    audioSettings: 'Audio Settings',
    displaySettings: 'Display Settings',
    languageAndThemes: 'Language and Themes',
    autoAdjustScreenBrightness: 'Automatically adjust the screen brightness',
    screenBrightness: 'Screen brightness',
    autoTurnOffScreen: 'Automatic screen-off',
    autoTurnOffScreenTime: 'Automatic screen-off time',
    autoScreenSaver: 'Automatic screen saver',
    autoScreenSaverTime: 'Automatic screen saver time',
    displayDeviceSn: 'Display SN',
    displayIp: 'Display IP',
    displayIdentityCard: 'Display Cloud Certificate',
    volume: 'Volume',
    language: 'Language',
    displayCode: "Display the mini-program code",
    themeMode: "Work theme",
    cn: 'Chinese',
    en: 'English',
    es: 'Spanish',
    fr: 'French',
    de: 'German',
    ru: 'Russian',
    ar: 'Arabic',
    pt: 'Port.',
    ko: 'Korean',
    standardMode: 'Standard Mode',
    simpleMode: 'Simple Mode',
    firstLogin: 'This is my first time logging into the backend',
    backlight: 'Screen backlight',
    brightness: 'White fill light',
    nirBrightness: 'Infrared supplementary light',
    never: 'Never',
    min1: '1 Min',
    min2: '2 Min',
    min3: '3 Min',
    min4: '4 Min',
    min5: '5 Min',
    // 网络配置
    networkConfiguration: 'Network configuration',
    otherConfiguration: 'Other configurations',
    ipConfiguration: 'IP configuration',
    devicePassword: 'Device password ',
    protocolPassword: 'Communication protocol password',
    networkType: 'Network type ',
    ethernet: 'Ethernet',
    wifiName: 'Wi-Fi name',
    wifiPassword: 'Wi-Fi password',
    dhcpModeSelection: 'DHCP mode',
    dhcpMode: 'Automatic acquisition',
    customNetworkConfiguration: 'Manual configuration',
    ipAddress: 'IP address',
    gateway: 'Gateway',
    subnetMask: 'Subnet mask',
    dnsServer: 'DNS server',
    mac: 'Mac address',
    // MQTT配置
    mqttRelatedConfiguration: 'MQTT configuration',
    mqttConnectionInformation: 'MQTT connection information',
    sessionConfiguration: 'Session configuration',
    serverAddress: 'Server address',
    clientID: 'Client ID',
    userName: 'User name',
    userPassword: 'User password',
    topicPrefix: 'Theme prefix',
    onlineChecking: 'Online verification',
    onlineCheckingTimeout: "Online verification timeout",
    cleanSession: 'Clear the session',
    clientIdSuffix: 'ClientId suffix',
    willTopic: 'WillTopic',
    enterpriseWechat:'The Enterprise wechat mode is ineffective',
    // 人脸配置
    faceRelatedConfiguration: 'Face configuration',
    functionalInformation: 'Functional information',
    prompt: 'Prompt',
    faceSimilarityThreshold: 'Face similarity threshold',
    livenessDetectionFunction: 'Live detection function',
    livenessDetectionThreshold: 'Live detection threshold',
    infraredImageDisplay: "Infrared image display",
    maskRecognition: "Mask recognition",
    strangerVoice: "Stranger's voice",
    voiceMode: "Voice mode",
    voiceModeDate: 'Customized greeting',
    imageSaveType: "Image saving type",
    saveStrangerImage: "Save images of strangers",
    fullView: "Panoramic view",
    face: "Face",
    broadcastPleaseRegisterFirst: 'Play please register for a facial recognition voucher',
    broadcastHelloStranger: 'Play unregistered personnel',
    broadcastName: 'Play the name',
    broadcastGreeting: 'Play a custom greeting',
    greeting: 'Greeting',
    broadcastWelcome: 'Play welcome',
    recognitionSwitch: 'Re-detection switch',
    // 系统配置
    systemRelatedConfiguration: 'System configuration',
    functionSwitch: 'Function switch',
    cardSwipingSwitch: 'Card swiping switch',
    passwordSwitch: 'Password switch',
    cloudCertificateSwitch: 'Cloud Certificate switch',
    strangerImage: 'Stranger save picture switch',
    physicalCardNumber: 'Physical card number',
    cloudCertificateAcquisition: 'Cloud Certificate Acquisition',
    heartbeatConfig: 'Heartbeat config',
    heartbeatSwitch: 'Heartbeat switch',
    heartRateInterval: 'Heart rate interval',
    heartbeatTopic: 'Heartbeat Topic',
    heartbeatContent: 'Heartbeat content',
    basicInformation: 'Basic information',
    deviceMac: 'Device Mac',
    uuid: 'UUID',
    sn: 'SN',
    model: 'Model',
    version: "Version",
    appVersion: "Firmware version",
    releaseTime: "Update time",
    totaldisk: 'Total storage space',
    freedisk: 'Remaining space',
    // 通行配置
    passageConfiguration: 'Passage configuration',
    functionConfiguration: 'Function Configuration',
    numberOfPassageRecords: 'The maximum number of passage records',
    durationOfRelayOpening: 'Duration of relay opening',
    alarmSwitch: 'Alarm switch',
    fireAlarmSwitch: 'Fire alarm switch',
    fireAlarmStatus: 'Fire alarm status',
    normal: 'Normal',
    warning: 'Warning',
    tamperSwitch: 'Tamper switch',
    uploadToCloudSwitch: 'Face upload switch',
    // 时钟配置
    clockConfiguration: 'Clock configuration',
    timeSynchronizationSwitch: 'Time synchronization switch',
    timeSynchronizationServerIP: 'Time synchronization server IP',
    timedSynchronizationTime: 'Timed synchronization time',
    timeZone: 'Time zone',
    setDeviceTime: 'Set device time',
    restartAfterSetting: 'After setting, the device will automatically restart',
    // 云证激活
    cloudCertificateActivation: 'Cloud Certificate Activation',
    activationKey: 'Activation key',
    cloudTips1: 'Please enter the activation key and make sure there are no Spaces',
    cloudTips2: 'After successful activation, the device will connect to the cloud authentication service',
    confirmActivation: 'Confirm activation',
    activationInProgress: 'Activation in progress...',
    activationFailed: 'Activation failed',
    activationSuccessful: 'Activation successful',
    // 密码修改
    passwordModification: 'Password modification',
    password: 'Password',
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    passwordRule: 'Password rule recommendation',
    passwordLength: 'Length ≥6',
    cannotBeTheSame: 'All characters cannot be the same',
    cannotOrder: 'It cannot contain at least three consecutive numbers or sequences of lowercase letters (in ascending or descending order).',
    cannotWeakPassword: 'It cannot be common weak passwords, including',
    submit: 'Submit',
    saveConfig: 'Save config',
    msg_please_enter: 'Please enter the content',
    msg_inputPassword: 'Please enter the password.',
    msg_oldPasswordError: 'The old password is incorrect',
    msg_password_mismatch: 'The passwords entered twice are inconsistent',
    msg_password_min_length: 'The password length should be at least 6 characters',
    msg_is_weak_password: 'This is a weak password. Please reset it',
    msg_pswChangeSuccessAndLogin: 'Your password has been modified successfully. Please log in again',
    msg_pswChangeSuccess: 'The password has been modified successfully.',
    msg_pswChangeFail: 'Password modification failed.',
    msg_saveSuccess: 'Saved successfully',
    msg_saveFail: 'Save failed',
    msg_formFilled: 'Please check whether the form is filled out correctly',
    msg_number_0_23: 'Only supports 0 to 23',
    msg_number_0_24: 'Only supports 0 to 24',
    msg_noChange: 'No configuration changes need to be saved',
    // Resource configuration
    resourceConfiguration: 'Resource configuration',
    backgroundImage: 'Background image',
    selectImage: 'Select image',
    uploadBackground: 'Upload background',
    uploading: 'Uploading...',
    backgroundUploadTip: 'Please upload a PNG image with pixel size of {n}. The image will be converted to Base64 format and then uploaded to the device',
    backgroundResolutionMismatch: 'Image resolution must be {n}',
    backgroundRequired: 'Please select a background image first',
    backgroundImageOnlyPNG: 'Please upload a PNG image',
    backgroundSizeLimit: 'Image size cannot exceed 5MB',
    backgroundParseFailed: 'Failed to read image, please retry',
    backgroundImageSelected: 'Image selected successfully',
    backgroundSuccess: 'Background uploaded successfully',
    backgroundFailed: 'Background upload failed',
    scanSettings: 'Scan Settings',
    scanSwitch: 'Scan Switch',
    scanInterval: 'Scan Interval',
  },
  // 人员设置 
  person: {
    idCard: 'Id number',
    userType: 'Type',
    userId: 'ID',
    name: 'name',
    user: 'User',
    administrator: 'Administrator',
    voucher: 'Voucher',
    permission: 'Permission',
    placeholderUserId: 'Please enter the userId',
    placeholderName: 'Please enter the name',
    addUser: 'Add user',
    editUser: 'Edit user',
    userNotExist: 'The personnel do not exist',
    oneClickClear: 'One-click clear',
    clearTips: 'This operation will permanently delete all personnel, credentials and permission data. Do you want to continue?',
    clearSuccess: 'Cleared successfully',
    clearFailed: 'Failed to clear',
  },
  voucher: {
    password: 'Password',
    card: 'Card',
    face: 'Face',
    finger: 'Finger',
    code: 'Code',
    codeType: 'Code Type',
    passthroughCode: 'Passthrough Code',
    staticCode: 'Static Code',
    dynamicCode: 'Dynamic Code',
    placeholderCode: 'Please enter code certificate',
    placeholderPwd: 'Please enter the password credential',
    placeholderCard: 'Please enter the card voucher',
    validPassword: 'Please enter six digits',
    validCard: 'Please enter 8 digits or letters',
    photoRegistration: 'Photo registration',
    featureValueRegistration: 'Feature value registration',
    fingerRegistration: 'Finger registration',
    fingerFeatureRegistration: 'Feature value registration',
    fingerInput: 'Please put your finger on the fingerprint scanner',
    fingerRemainingTime: 'Remaining time',
    fingerInputting: 'Inputting...',
    startFingerInput: 'Start inputting fingerprint',
    fingerInputTips: 'Please enter the fingerprint feature value',
    fingerWaitInput: 'Waiting for input',
    fingerInputNow: 'Inputting fingerprint...',
    fingerInputSuccess: 'Input success',
    fingerInputFailed: 'Finger input failed',
    fingerReTry: 'Finger input failed, please try again',
    fingerFilled: 'Finger input success, feature value has been automatically filled',
    fingerFailed: 'Finger input failed',
    fingerTimeout: 'Input timeout',
    fingerInputTimeout: 'Finger input timeout, please try again',
    fingerError: 'Input failed',
    fingerInputError: 'Finger input failed, please try again',
    fingerInputed: 'Fingerprint has been entered',
    fingerReInput: 'Re enter fingerprint',
  },

  permission: {
    deletePermission: 'Delete permission',
    addPermission: 'Add permissions',
    permissionId: 'Permission ID',
    userId: 'User ID',
    timeRange: 'Time interval',
    extra: 'Extra',
    effectiveType: 'Effective Type',
    effectiveTime: 'Effective Time',
    effectiveWeek: 'Effective Week',
    timePeriod: 'Time period',
    addTimePeriod: 'Add a time period',
    modify_previous_time: 'Please modify the previously added time period first',
    cannot_be_earlier: 'The end time must not be less than the start time',
    times_cannot_overlap: 'The selected times cannot overlap',
    choose_time_range: 'Please select the effective time range',
    unlimitedMode: 'Unlimited mode',
    usualMode: 'Usual mode',
    dailyMode: 'Daily mode',
    weeklyRepetitionMode: 'Weekly repetition mode',
    time_range: 'Time range',
  },

  common: {
    startDate: 'Start date',
    endDate: 'End date',
    to: 'to',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    batchDelete: 'Batch Delete',
    startTime: 'Start time',
    endTime: 'End time',
    monday: 'Monday',
    tuseday: 'Tuseday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saterday: 'Saterday',
    sunday: 'Sunday',
    placeholder: 'Please enter',
    placeholderSelect: 'Please select',
    closeTips: 'Is it confirmed to be closed?',
    deleteTips: 'Are you sure to delete it?',
    deleteSuccess: 'Deleted successfully',
    addSuccess: 'Added successfully',
    editSuccess: 'Edited successfully',
    saveSuccess: 'Saved successfully',
    tips: 'Tips',
    operation: 'Operation',
    query: 'Query',
    reset: 'Reset',
    noData: 'No data available for the time being.',
    export: 'Export',
    success: 'success',
    failure: 'failure',
    incorrectFormat: 'Incorrect format',
    integerFormat: 'Should be an integer greater than or equal to 0',
    positiveIntegerFormat: 'Should be an integer greater than 0',
    noDataSaved: 'No data needs to be saved',
    chinese: 'Chinese',
    english: 'English',
    spanish: 'Spanish',
    french: 'French',
    german: 'German',
    russian: 'Russian',
    arabic: 'Arabic',
    portuguese: 'Portuguese',
    korean: 'Korean',
    detail: 'Detail',
    clearTips: 'Confirm clear?',
    clearSuccess: 'Cleared successfully',
  },

  log: {
    accessMethod: 'Access method',
    passingTime: 'Passing time',
    accessPass: 'Access pass',
    accessResult: 'Access result',
    accessPhoto: 'Access photo',
    viewPhotos: 'View photos'
  },

  error: {
    networkError: 'Network request failed, please check your connection',
    timeout: 'Request timeout, please check your network or try again later',
    serverError: 'Server internal error, please try again later',
    notFound: 'Requested resource does not exist',
    unauthorized: 'Unauthorized, please login again',
    noResponse: 'Unable to connect to server, please check network or server status',
    unknownError: 'Request failed, error code:',
    requestFailed: 'Request failed'
  },
  
  security: {
    keyId: 'Key ID',
    keyType: 'Key Type',
    keyEncoding: 'Key Encoding',
    keyValue: 'Key Value',
    startTime: 'Start Time',
    expirationTime: 'Expiration Time',
    newKey: 'Add Key',
    clearKey: 'Clear Key',
    validTime: 'Valid Time',
  }
}